// GENERATED by tools/scripts/generate-icons.mjs from libs/icons/svg/outline/chart-pie.svg. Do not edit.

import type { Glyph } from '../../types'

export const glyph: Glyph = {
  name: 'chart-pie',
  version: 'outline',
  paths: [
    {
      d: 'M10.5 6a7.5 7.5 0 1 0 7.5 7.5h-7.5V6Z',
    },
    {
      d: 'M13.5 10.5H21A7.5 7.5 0 0 0 13.5 3v7.5Z',
    },
  ],
}
